import React, {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
//import {Provider} from "react-redux"

import Spinner from "./components/loading/Spinner";
import {AuthProvider} from "./auth/useAuth";
//import store from "./store";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    //setTimeout(() => this.setState({loading: false}), 3000);
    this.setState({loading: false});
  }

  render() {
    return (
      <div>
        {!this.state.loading ? (
          <StrictMode>
            <BrowserRouter>
              <AuthProvider>
                {/*<Provider store={store}>*/}
                {/*  <App/>*/}
                {/*</Provider>*/}
                <App/>
              </AuthProvider>
            </BrowserRouter>
          </StrictMode>
        ) : (
          <Spinner/>
        )}
      </div>
    )
  }
}

createRoot(document.getElementById('react')).render(
  <Main/>
)
